import State from '../core/State';
import initialState from '../initialState';
import Work from '../entity/Work';

export const startFetchingWork = () => (state: State): State => ({
  ...state,
  work: {
    ...state.work,
    fetching: state.work.fetching + 1,
  },
});

export const finishFetchingWork = () => (state: State): State => ({
  ...state,
  work: {
    ...state.work,
    fetching: state.work.fetching - 1,
  },
});

export const setWork = (work: Work) => (state: State): State => ({
  ...state,
  work: {
    ...state.work,
    item: work,
  },
});

export const disposeWork = () => (state: State): State => ({
  ...state,
  work: initialState.work,
});
